@if (showTable) {
  <snelstart-ui-table [config]="tableConfig"
                      [displayName]="relationTypeToPluralDutchTranslationsMap[type]"
                      loadType="Pagination"
                      prefix="relations">
    <snelstart-ui-table-col [asTag]="true"
                            [name]="COLUMN.Code"
                            columnType="number"
                            displayName="Code"
                            i18n-displayName
                            markText
                            width="80px">
      <snelstart-ui-table-col-header>
        <ng-container>#</ng-container>
      </snelstart-ui-table-col-header>
    </snelstart-ui-table-col>

    <snelstart-ui-table-col [displayName]="relationTypeToDutchTranslationsMap[type]"
                            [name]="COLUMN.Name"
                            markText
                            width="250px">
    </snelstart-ui-table-col>

    <snelstart-ui-table-col [name]="COLUMN.ContactPersonName"
                            displayName="Contactpersoon"
                            markText
                            width="250px">
    </snelstart-ui-table-col>

    <snelstart-ui-table-col [name]="COLUMN.AddressCity"
                            columnType="string"
                            displayName="Plaats"
                            i18n-displayName
                            markText
                            width="190px">
    </snelstart-ui-table-col>

    <snelstart-ui-table-col [name]="COLUMN.FiscalIdentifier"
                            displayName="Fiscaal nummer"
                            width="150px">
      <snelstart-ui-table-col-data>
        <ng-template let-FiscalIdentifier>
          @if (getDuplicateTaxId(FiscalIdentifier)! > 0) {
            <a (click)="this.alertDuplicateTaxIds($event, FiscalIdentifier)">
              <ng-container>
                <snelstart-ui-badge [icon]="'triangle-exclamation'" [small]="false" [type]="'error'"
                                    label="{{FiscalIdentifier}}"></snelstart-ui-badge>
              </ng-container>
            </a>
          }
          @else if (!getValidTaxId(FiscalIdentifier)) {
            <a (click)="this.alterInvalidTaxId($event, FiscalIdentifier)">
              <ng-container>
                <snelstart-ui-badge [icon]="'xmark'" [small]="false" [type]="'warning'"
                                    label="{{FiscalIdentifier}}"></snelstart-ui-badge>
              </ng-container>
            </a>
          }
          @else {
            <ng-container>
              <a>{{ FiscalIdentifier }}</a>
            </ng-container>
          }
        </ng-template>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>

    @if (this.intermediaryEntity.beconId !== undefined && this.intermediaryEntity.certValidUntil !== undefined) {
      <snelstart-ui-table-col [name]="COLUMN.Id"
                              [showFilter]="false"
                              [showSort]="false"
                              displayName="Uitstel 2025"
                              width="140px">
        <snelstart-ui-table-col-data>
          <ng-template let-Id>
            @if (getValueUitstel(Id) === undefined) {
              <ng-container>
                <snelstart-ui-badge [label]="'Status ophalen...'" [small]="false"
                                    [type]="'error'"></snelstart-ui-badge>
              </ng-container>
            } @else if (getValueUitstel(Id)) {
              <ng-container>
                <a (click)="this.changeUitstel($event, Id, true)" type="link">
                  <snelstart-ui-badge [icon]="'check'" [label]="'Aangemeld'" [small]="false"
                                      [type]="'success'"></snelstart-ui-badge>
                </a>
              </ng-container>
            } @else if (!getCouldHaveUitstel(Id)) {
              <ng-container>
                <a (click)="this.changeUitstel($event, Id, false)" type="link">
                  <snelstart-ui-badge [icon]="'xmark'" [label]="'Niet beschikbaar'" [small]="false"
                                      [type]="'default'"></snelstart-ui-badge>
                </a>
              </ng-container>
            }
            @else {
              <ng-container>
                <a (click)="this.changeUitstel($event, Id, false)" type="link">
                  <snelstart-ui-badge [icon]="'xmark'" [label]="'Niet aangemeld'" [small]="false"
                                      [type]="'warning'"></snelstart-ui-badge>
                </a>
              </ng-container>
            }
          </ng-template>
        </snelstart-ui-table-col-data>
      </snelstart-ui-table-col>
    }

    <!--    @if (this.intermediaryFormGroup.get('certValidUntil')?.getRawValue() !== undefined) {-->
    <!--      <snelstart-ui-table-col [name]="COLUMN.Id"-->
    <!--                              [showFilter]="false"-->
    <!--                              [showSort]="false"-->
    <!--                              displayName="Machtigingen"-->
    <!--                              width="210px">-->
    <!--        <snelstart-ui-table-col-data>-->
    <!--          <ng-template let-Id>-->
    <!--            @if (getValueMuma(Id) === undefined || getValueMuma(Id) === 0) {-->
    <!--              <ng-container>-->
    <!--                <a (click)="this.goToMumaDossier($event, Id)" type="link">-->
    <!--                  <snelstart-ui-badge [label]="'Geen actieve machtigingen'" [small]="false"-->
    <!--                                      [type]="'default'"></snelstart-ui-badge>-->
    <!--                </a>-->
    <!--              </ng-container>-->
    <!--            } @else if (getValueMuma(Id) === 999) {-->
    <!--              <ng-container>-->
    <!--                <a (click)="this.goToMumaDossier($event, Id)" type="link">-->
    <!--                  <snelstart-ui-badge [label]="'Machtiging activeren'" [small]="false"-->
    <!--                                      [type]="'warning'"></snelstart-ui-badge>-->
    <!--                </a>-->
    <!--              </ng-container>-->
    <!--            } @else if (getValueMuma(Id)! >= 0 && getValueMuma(Id)! < 999) {-->
    <!--              <ng-container>-->
    <!--                <a (click)="this.goToMumaDossier($event, Id)" type="link">-->
    <!--                  <snelstart-ui-badge [label]="this.getValueMuma(Id) + ' actieve machtigingen'"-->
    <!--                                      [small]="false"-->
    <!--                                      [type]="'active'"></snelstart-ui-badge>-->
    <!--                </a>-->
    <!--              </ng-container>-->
    <!--            }-->
    <!--          </ng-template>-->
    <!--        </snelstart-ui-table-col-data>-->
    <!--      </snelstart-ui-table-col>-->
    <!--    }-->

    <snelstart-ui-table-col [isVisible]="false"
                            [name]="COLUMN.AddressPostalCode"
                            columnType="string"
                            displayName="Postcode"
                            i18n-displayName
                            markText
                            width="190px">
    </snelstart-ui-table-col>

    <snelstart-ui-table-col [isVisible]="false"
                            [name]="COLUMN.PhoneNumber"
                            columnType="string"
                            displayName="Telefoon"
                            i18n-displayName
                            markText
                            width="190px">
    </snelstart-ui-table-col>

    <snelstart-ui-table-col [isVisible]="false"
                            [name]="COLUMN.Email"
                            columnType="string"
                            displayName="E-mail"
                            i18n-displayName
                            markText
                            width="190px">
    </snelstart-ui-table-col>
  </snelstart-ui-table>
}

<snelstart-ui-dialog></snelstart-ui-dialog>

<snelstart-ui-dialog-definition [(visible)]="dialogAdministrationVisible"
                                [useTitleBorder]="true"
                                id="tm"
                                size="md"
                                title="Kantooradministratie selecteren">

  <snelstart-ui-dialog-header-content>
    Het klantenoverzicht voor fiscaal, jaarrapportage en salaris is volledig geïntegreerd met relaties die zijn
    opgenomen in de administratie van je kantoor in Snelstart Polaris of SnelStart Web.
  </snelstart-ui-dialog-header-content>

  <snelstart-ui-dialog-body>
    <div>
      <form [formGroup]="adminInputFg">
        <div class="row align-items-center">
          <div class="col-auto">
            <label>Heb je een SnelStart administratie voor je eigen kantoor?</label>
          </div>
          <div class="col-auto">
            <snelstart-ui-select-form-control [options]="optionsJaNee"
                                              [required]="true"
                                              class="custom-input-250"
                                              formControlName="kantoorAdministratie"
                                              id="selectedAdminId"
            >
            </snelstart-ui-select-form-control>
          </div>
        </div>
      </form>

      @if (this.adminInputFg.get('kantoorAdministratie')?.value === false) {
        <snelstart-ui-alert type="info">
          Maak via 'Administratiebeheer' in Snelstart Polaris of Web een kantooradministratie aan en keer
          terug naar dit scherm. Of neem contact op met onze klantenservice (tel. 0222 -
          363060). Wij helpen je graag.
        </snelstart-ui-alert>
      }

      @if (this.adminInputFg.get('kantoorAdministratie')?.value === true) {
        <form [formGroup]="adminInputFg">
          <div class="row align-items-center">
            <div class="col-auto">
              <label>Selecteer je eigen kantooradministratie</label>
            </div>
            <div class="col-auto">
              <snelstart-ui-select-form-control [options]="optionsAministratie"
                                                [required]="true"
                                                class="me-1 custom-input-250"
                                                formControlName="selectedAdminId"
                                                id="selectedAdminId"
              >
              </snelstart-ui-select-form-control>
            </div>
          </div>
        </form>
      }
    </div>
  </snelstart-ui-dialog-body>

  <snelstart-ui-dialog-buttons class="d-flex">
    @if (!this.intermediaryEntity.sstPrimaryAdminId) {
      <snelstart-ui-button
        (click)="this.submitAdministrationId()"
        [disabled]="this.adminInputFg.invalid || migratingClients"
        icon="check"
        id="save"
        ignoreClick
        type="primary"
      >
        Importeren {{ getSelectedKantoorNaam() }}
      </snelstart-ui-button>
    }
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

<snelstart-venture-fiscaal-domain-logic-muma
  [(dialogVisible)]="this.dialogMumaVisible"
  [name]="client.name!"
  [mumaList]="this.mumaList"
>
</snelstart-venture-fiscaal-domain-logic-muma>

<!--<snelstart-venture-fiscaal-domain-logic-client-migration-->
<!--  [(dialogVisible)]="this.dialogMigrationVisible" ></snelstart-venture-fiscaal-domain-logic-client-migration>-->

<snelstart-ui-dialog-definition
  [(visible)]="showDuplicateDialog"
  size="medium"
  title="Let op: dubbele fiscale nummers in de klantenlijst">
  <snelstart-ui-dialog-body>
    <p>Het fiscale nummer <b>{{ duplicateTaxId }}</b> komt <b>{{ duplicateCount }}</b> keer voor in de klantenlijst.
      Dit kan leiden tot verwerkingsproblemen.</p>
    <p><b>Los dit als volgt op:</b><br/>
      1) Filter de klantenlijst eerst op de kolom ‘Fiscaal nummer’ en kijk waar het nummer meerdere keren voorkomt.
      Deze zijn rood gearceerd in de lijst.<br/><br/>
      2)

      <!--            Selecteer vervolgens de klant en beoordeel is dit dezelfde belastingplichtige of niet. Zo nee, pas het fiscale nummer aan bij de 3 puntjes wijzigen. Zo ja,-->
      <!--            selecteer die gearchiveerd kan worden, klik op de drie puntjes aan de rechterkant van de rij en-->
      <!--            kies ‘Archiveren’. Herhaal dit voor alle klanten die je wilt archiveren.-->

      Selecteer vervolgens de klant en beoordeel of dit dezelfde belastingplichtige betreft.<br/><br/>
      - Is dit niet het geval? Pas dan een of meerdere fiscale nummer(s) aan via de drie puntjes → Wijzigen.<br/><br/>
      - Is dit wél dezelfde belastingplichtige en kan de klant worden gearchiveerd? Klik
      dan op de drie puntjes aan de rechterkant van de rij en kies Archiveren voor de klant die gearchiveerd mag worden.<br/><br/>

      Herhaal deze stappen voor alle klanten die je wilt archiveren.<br/><br/>
      De klant wordt dan verplaatst uit de actieve klantenlijst naar ‘Gearchiveerde klanten’. De
      rode melding verdwijnt bij de eerstvolgende (dagelijkse) synchronisatie.</p>
  </snelstart-ui-dialog-body>
  <snelstart-ui-dialog-buttons>
    <snelstart-ui-button (click)="showDuplicateDialog = false" btn-x type="primary">
      Sluiten
    </snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
